class TableActionsComponent extends Component
{

    component_interface;

    constructor() {
        let intface = new TableActionsInterface();
        super(TableActionsComponent, intface.selectors.getComponentSelector());
        this.component_interface = intface;
        this.registerListeners();


    }



    registerListeners() {
        super.registerListeners();

        let select_listener = new TableActionsSelectListener(
            this.component_interface.selectors.getActionsSelectSelector(),
            this.component_interface
        );

    }






}

$(document).ready(function (e){
    Components.addComponent(
        new TableActionsComponent()
    );
});

